import styled from "styled-components";
import { Paper } from "@material-ui/core";

const StyledPaper = styled(Paper)`
    overflow: scroll;
`;

export default StyledPaper;
